import type { ImagesConfig } from '@layers/web/stores/types/config.ts'

const useConfigStore = defineStore('config', {
  state: (): {
    API_BASE_PATH: string
    API_URL: string
    imagesConfig: ImagesConfig
  } => {
    const { public: { API_BASE_PATH, API_URL, images: imagesConfig } } = useRuntimeConfig()

    return {
      API_BASE_PATH: API_BASE_PATH as string,
      API_URL: API_URL as string,
      imagesConfig: imagesConfig as ImagesConfig,
    }
  },
  getters: {},
  actions: {},
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useConfigStore, import.meta.hot))
}

export { useConfigStore }